// @flow
const fileSelectViewStyles = {
  container: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 600,
    margin: '0 auto'
  }),

  dropzone: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: 200,
    padding: theme.spacing(4),
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover
    }
  }),

  dropzoneActive: (theme: Object) => ({
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover
  }),

  dropzoneAccept: (theme: Object) => ({
    borderColor: theme.palette.success.main,
    backgroundColor: theme.palette.success.light + '20'
  }),

  dropzoneReject: (theme: Object) => ({
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.error.light + '20'
  }),

  dropzoneContent: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  }),

  uploadIcon: (theme: Object) => ({
    fontSize: 64,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2)
  }),

  title: (theme: Object) => ({
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1)
  }),

  subtitle: (theme: Object) => ({
    color: theme.palette.text.secondary
  }),

  selectedFile: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.success.light + '20',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.success.main}`
  }),

  fileIcon: (theme: Object) => ({
    color: theme.palette.success.main,
    fontSize: 32
  }),

  fileName: (theme: Object) => ({
    fontWeight: 500,
    color: theme.palette.text.primary
  }),

  fileSize: (theme: Object) => ({
    color: theme.palette.text.secondary
  }),

  instructions: (theme: Object) => ({
    width: '100%',
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`
  }),

  instructionTitle: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1)
  }),

  instructionList: (theme: Object) => ({
    color: theme.palette.text.secondary,
    '& ul': {
      margin: 0,
      paddingLeft: theme.spacing(2.5)
    },
    '& li': {
      marginBottom: theme.spacing(0.5)
    },
    '& strong': {
      color: theme.palette.text.primary
    }
  }),

  templateLink: (theme: Object) => ({
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  }),

  downloadIcon: (theme: Object) => ({
    fontSize: 18,
    marginRight: theme.spacing(0.5)
  }),

  actions: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    width: '100%',
    marginTop: theme.spacing(3)
  }),

  cancelButton: (theme: Object) => ({
    minWidth: 100
  }),

  uploadButton: (theme: Object) => ({
    minWidth: 100
  })
};

export default fileSelectViewStyles;
